import React from "react";
import "./styles/StatusBadge.css";

/**
 * StatusBadge - Status indicator pill
 * @param {Object} props
 * @param {string} props.status - Tone: 'neutral' | 'success' | 'warning' | 'danger' |
 *   'info' | 'accent' | 'pending'. The stock-level names 'active' | 'low' | 'out'
 *   are still accepted and map onto success / warning / danger.
 * @param {string} props.label - Display label
 * @param {boolean} props.dot - Show the leading dot, defaults to true
 */
const StatusBadge = ({ status = "neutral", label, dot = true }) => {
  return (
    <span className={`status pill ${status}`} title={label}>
      {dot && <span className="statusDot" />}
      {label}
    </span>
  );
};

export default StatusBadge;
